<template>
  <div class="jobs-list">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <div class="jobs-ul">
      <div
        class="jobs-li" v-for="(user, index) in filteredList" :key="index"
      >
        <div class="permission-company">
          <span style="margin-left: 10px">{{ user.name || user.email }}</span>
          <PermissionObject :user="user" @update="(permission) => save(permission, user.id)" class="name" :id="user.id"
                            :plan-id="$route.query.plan || $route.params.id">
            <img src="@/assets/settings.svg"/>
          </PermissionObject>
        </div>
      </div>
    </div>
    <el-button style="margin-top: 20px; width: 100%" @click="$router.back()" type="primary">Сохарнить</el-button>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import {getPlans} from "../../../firestore/plan";
import PermissionObject from "../Users/PermissionObject";

export default {
  name: 'PlanIndex',
  components: {PermissionObject, draggable},

  data() {
    return {
      loader: false,
      search: '',
      users: [],
      form: {
        is_directive: false
      }
    };
  },

  mounted() {
    this.fetchUsers();
  },

  methods: {
    async save(user, id) {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(id)
        .update({
          ...user._save,
          plan_permission: {
            ...user.plan_permission,
            [this.$route.params.id]: {
              available_jobs: user.available_jobs,
              available_objects: user.available_objects,
              usePermission: user.usePermission,
            }
          }
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно',
          message: 'Доступ компании изменен',
          type: 'success',
        });
        }).catch((error) => {
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
    async fetchUsers() {
      this.loader = true;
      const result = [];

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {

          data.forEach((subDoc) => {
            let _data = subDoc.data();

            result.push({..._data, id: subDoc.id,
              usePermission: _data.plan_permission && _data.plan_permission[this.$route.params.id] && _data.plan_permission[this.$route.params.id].usePermission || false,
              available_jobs: _data.plan_permission && _data.plan_permission[this.$route.params.id] && _data.plan_permission[this.$route.params.id].available_jobs || {},
              available_objects: _data.plan_permission && _data.plan_permission[this.$route.params.id] && _data.plan_permission[this.$route.params.id].available_objects || [],
              save: {
                ..._data
              }
            });

          });
        }).finally(() => {
        this.users = result.filter((r) => r.isCompany);

        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  },

  computed: {
    filteredList() {
      return this.users.filter(plan => {
        if (!plan.name) return true
        return String(plan.name).toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}

.permission-company {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Plan/Users.vue